// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fl-a";
export var fulfillmentFormRail = "_fl-9";
export var headerTitleRow = "_fl-c";
export var orderDetailsWrapper = "_fl-7";
export var orderLinkTrigger = "_fl-2";
export var paymentInformationGrid = "_fl-h";
export var paymentSummaryColumn = "_fl-i";
export var shipmentContainer = "_fl-b";
export var shipmentDetailsMainPane = "_fl-8";
export var shipmentNavigationCard = "_fl-5";
export var shipmentNavigationRail = "_fl-3";
export var shipmentNavigationRailHeader = "_fl-4";
export var shipmentSummaryFact = "_fl-e";
export var shipmentSummaryGrid = "_fl-d";
export var shipmentSummaryMetadataRow = "_fl-f";
export var shipmentSummaryTags = "_fl-g";
export var shipmentWorkspace = "_fl-0";
export var shipmentWorkspaceContent = "_fl-6";
export var shipmentWorkspaceHeader = "_fl-1";